import * as React from 'react';
import { Chips } from '@cian/ui-kit';
import { FORM_ANCHOR } from './constants/constants';
import { FormCardLayout } from '../../components/RequestFormV2/FormCardLayout';
import { useInView } from '../../hooks/useInView';

export const RequestFormV2Container = ({ setIsFormVisible }: { setIsFormVisible: (isVisible: boolean) => void }) => {
  const [formRef, isFormInView] = useInView<HTMLDivElement>({
    threshold: 0.4,
  });

  React.useEffect(() => {
    setIsFormVisible(isFormInView);
  }, [isFormInView, setIsFormVisible]);

  return (
    <div ref={formRef} id={FORM_ANCHOR} data-testid="RequestFormV2">
      <FormCardLayout
        question="Какую квартиру ищете?"
        image="https://images.cdn-cian.ru/imgmobile/builders/kpn/landing/rooms.png"
      >
        <Chips
          options={[
            { value: 'Студия', label: 'Студия' },
            { value: '1-комнатная', label: '1-комнатная' },
            { value: '2-комнатная', label: '2-комнатная' },
            { value: '3-комнатная', label: '3-комнатная' },
            { value: '4-комнатная', label: '4-комнатная' },
            { value: '5-комнатная', label: 'Хочу 5-комнатный дворец. Или больше!' },
          ]}
        />
      </FormCardLayout>
    </div>
  );
};
